import React, { useEffect, useRef } from 'react';
import Chart from 'react-apexcharts';
import './directcss/PieChart.scss'

const PieChart = ({
    labels,
    colors,
    series,
    height,
    legendPosition = 'bottom',
    legendHorizontalAlign = 'center',
    legendOffsetY = 10,
    legendFontSize = '14px'
}) => {

    const chartOptions = {
        labels,
        colors,
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '85%',
                },
            },
        },
        legend: {
            show: true,
            position: legendPosition,
            horizontalAlign: legendHorizontalAlign,
            offsetY: legendOffsetY,
            fontSize: legendFontSize,
            markers: {
                width: 8,
                height: 8,
                strokeWidth: 0,
                strokeColor: '#fff',
                radius: 4,
                offsetX: 0,
                offsetY: 0,
            },
            formatter: (seriesName, { seriesIndex }) => `${seriesName} : ${series[seriesIndex]}`,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                },
            },
        ]
    };

    return <Chart options={chartOptions} series={series} type="donut" width="100%" height={height} />
};


export default PieChart;